import React from 'react';
import PropTypes from 'prop-types';
import { isClient } from '@tcp/core/src/utils';
import PixleeReviewWidget from '../../PixleeReviewWidget';
import ProductReviewsContainer from '../../ProductReviews/container/index.async';

const ProductReviewsWidget = ({
  isPixleeWidget,
  isBVWidget,
  reviewsCount,
  ratingsProductId,
  bazaarVoice,
  starRatingClicked,
  handleRatingClick,
  isNewPJPPDPRedesignEnabled,
  isPDPtab,
  isPDPRedesignEnabled,
  isStyleColorRnREnabled,
}) => {
  if (isPixleeWidget) {
    return (
      <PixleeReviewWidget
        productSKU={ratingsProductId}
        isPDPRedesignEnabled={isPDPRedesignEnabled}
        isStyleColorRnREnabled={isStyleColorRnREnabled}
      />
    );
  }

  if (isBVWidget) {
    return (
      <ProductReviewsContainer
        expanded={false}
        reviewsCount={reviewsCount}
        ratingsProductId={ratingsProductId}
        isClient={isClient()}
        bazaarVoice={bazaarVoice}
        starRatingClicked={starRatingClicked}
        handleRatingClick={handleRatingClick}
        isNewPJPPDPRedesignEnabled={isNewPJPPDPRedesignEnabled}
        isPDPtab={isPDPtab}
      />
    );
  }

  return null;
};

export default ProductReviewsWidget;

ProductReviewsWidget.propTypes = {
  isPixleeWidget: PropTypes.bool.isRequired,
  isBVWidget: PropTypes.bool.isRequired,
  ratingsProductId: PropTypes.string.isRequired,
  reviewsCount: PropTypes.string.isRequired,
  starRatingClicked: PropTypes.bool.isRequired,
  bazaarVoice: PropTypes.shape({}).isRequired,
  handleRatingClick: PropTypes.func.isRequired,
  isNewPJPPDPRedesignEnabled: PropTypes.bool.isRequired,
  isPDPtab: PropTypes.bool.isRequired,
};
